import { assertAllUnionMembersHandled } from '../../lib/assertAllUnionMembersHandled';
import { SignupPayload } from '../../Views/Blocks/SignupBlock/classes/SignupPayload';
import { trackConversion } from '../Convert';
import { MarketingAutomationSubmissionType, Tracker } from './tracker';

const SUCCESSFUL_SIGNUP_GOAL_ID = '100154336' satisfies string;
const SIGNUP_STARTED_GOAL_ID = '100156974' satisfies string;
const MARKETO_FORM_SUBMISSION_GOAL_ID = '100161495' satisfies string;
const CHILIPIPER_CONCIERGE_SUBMISSION_GOAL_ID = '100161496' satisfies string;

export class ConvertTracker implements Tracker {
  fireSignupSuccess(
    signupData: SignupPayload,
    teamSize: number,
  ): Promise<void> {
    trackConversion({ conversionId: SUCCESSFUL_SIGNUP_GOAL_ID });
    return Promise.resolve();
  }

  fireSignupStep(step: number): Promise<void> {
    // Tracker is only concerned with when users have interacted with the signup form and begun the signup process.
    // Step 1 suggests that the user has interacted with with the signup form and begun the signup process.
    if (step === 1) {
      trackConversion({ conversionId: SIGNUP_STARTED_GOAL_ID });
    }

    return Promise.resolve();
  }

  fireMarketingAutomationSubmission(
    type: MarketingAutomationSubmissionType,
  ): Promise<void> {
    switch (type) {
      case MarketingAutomationSubmissionType.MarketoForm:
        trackConversion({ conversionId: MARKETO_FORM_SUBMISSION_GOAL_ID });
        break;
      case MarketingAutomationSubmissionType.ChiliPiperConcierge:
        trackConversion({
          conversionId: CHILIPIPER_CONCIERGE_SUBMISSION_GOAL_ID,
        });
        break;
      default:
        assertAllUnionMembersHandled(type);
    }

    return Promise.resolve();
  }
}
